import { ProductsApi, ProductResponse } from '@oncampusabroad/api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { initialApiState, ApiCallBase, createApiConfiguration } from './apiConfiguration';

interface ProductsCall extends ApiCallBase {
  response: ProductResponse[];
}

interface State {
  products: ProductsCall;
}

const initialState: State = {
  products: initialApiState,
};

export const fetchProducts = createAsyncThunk(
  'products/fetchProducts',
  async () => {
    try {
      const productsApi = new ProductsApi(createApiConfiguration());
      const response = await productsApi.getProducts();
      return response.data;
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  }
);

const ProductsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    resetProducts: (state) => {
      state.products = {
        ...initialApiState,
        response: state.products.response,
      };
    },
    resetProductsResponse: (state) => {
      state.products = {
        ...initialApiState,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchProducts.pending, (state) => {
      state.products.loading = 'pending';
    });
    builder.addCase(fetchProducts.fulfilled, (state, action) => {
      state.products.loading = 'succeeded';
      state.products.response = action.payload;
    });
    builder.addCase(fetchProducts.rejected, (state, action) => {
      state.products.loading = 'failed';
      state.products.error = action.payload;
    });
  },
});

export const {
  resetProducts,
  resetProductsResponse,
} = ProductsSlice.actions;

export default ProductsSlice.reducer;